import type PartySocket from "partysocket";
import { useLocalStorage } from "usehooks-ts";

import { useCallManager } from "../../hooks/useCallManager";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { DownloadAppOrContinueOnWeb } from "../Onboarding/DownloadAppOrContinueOnWeb";
import { CallManagerUI } from "./CallManagerUI";
import { CallManagerWrapper } from "./CallManagerWrapper";

export interface CallManagerProps {
  partySocket: PartySocket;
}
export function CallManager({ partySocket }: Readonly<CallManagerProps>) {
  const [hasChosenToContinueOnWeb, setHasChosenToContinueOnWeb] =
    useLocalStorage("continue-on-web", false);
  const callManagerProps = useCallManager();
  const isDesktop = useIsDesktop();

  const shouldAskToContinueOnWeb = !isDesktop && !hasChosenToContinueOnWeb;

  return (
    <CallManagerWrapper>
      {shouldAskToContinueOnWeb ? (
        <DownloadAppOrContinueOnWeb
          continueOnWeb={() => setHasChosenToContinueOnWeb(true)}
        />
      ) : (
        <CallManagerUI
          {...callManagerProps}
          partySocket={partySocket}
          mainSocket={callManagerProps.mainSocket}
          isLoading={callManagerProps.isLoading}
          refreshCalls={callManagerProps.refreshCalls}
          scriptDetectionLogs={callManagerProps.scriptDetectionLogs}
          clearScriptDetectionLogs={callManagerProps.clearScriptDetectionLogs}
        />
      )}
    </CallManagerWrapper>
  );
}
